import { Classes, Dialog } from "@blueprintjs/core";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { texts } from "modules/common/texts";
import React from "react";
import styles from "./PlanReconcileDialog.module.scss";

interface PlanReconcileDialogProps {
    isOpen: boolean;
    /** Сверка уже идёт — кнопки блокируем, чтобы не запустить второй раз */
    busy: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

/**
 * Подтверждение ручной сверки. Сверка идёт и сама, ночью, поэтому важно сказать
 * об этом до нажатия: обычно ждать до утра достаточно.
 */
export const PlanReconcileDialog = ({ isOpen, busy, onConfirm, onClose }: PlanReconcileDialogProps) => (
    <Dialog
        icon="help"
        canOutsideClickClose={!busy}
        onClose={onClose}
        title="Сверка плана с табелем"
        isOpen={isOpen}
        className="figma-dialog"
        backdropClassName="standard"
    >
        <div className={`${Classes.DIALOG_BODY} ${styles.body}`}>
            <p>Свести план работ с фактическим табелем прямо сейчас?</p>

            <p>
                Невыполненные работы переедут вправо, а сделанное досрочно спишется с будущих дней. Сегодняшний
                день учитывается только у тех сотрудников, кто уже отчитался за полный рабочий день.
            </p>

            <p className={styles.note}>Это происходит автоматически каждую ночь — обычно нажимать не требуется.</p>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
            <div className={styles.buttons}>
                <PlanrButton type="greenish" size="small" onClick={onConfirm} disabled={busy}>
                    Сверить
                </PlanrButton>

                <PlanrButton type="graybtn" size="small" onClick={onClose} disabled={busy}>
                    {texts.cancel}
                </PlanrButton>
            </div>
        </div>
    </Dialog>
);
